import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { Observable, catchError, map, take, throwError } from 'rxjs';

import { countPdfPages } from './ged-document-tags';

export interface GedDocumentFile {
  content: ArrayBuffer;
  pageCount: number;
  byteLength: number;
  objectUrl: string;
  safeUrl: SafeResourceUrl;
}

@Injectable({ providedIn: 'root' })
export class GedDocumentFileService {
  constructor(
    private httpApiService: HttpApiService,
    private sanitizer: DomSanitizer,
  ) {}

  download(accountId: any, documentId: any): Observable<GedDocumentFile> {
    return this.httpApiService
      .getWithOptions(`/accounts/${accountId}/documents/${documentId}`, {
        responseType: 'arraybuffer',
      })
      .pipe(
        take(1),
        map((content: ArrayBuffer) => this.toDocumentFile(content)),
        catchError((error: HttpErrorResponse) => {
          console.error(error);
          return throwError(error);
        }),
      );
  }

  saveAs(content: ArrayBuffer, name: string) {
    const url = window.URL.createObjectURL(
      new Blob([content], { type: 'application/pdf' }),
    );
    const link = document.createElement('a');

    link.href = url;
    link.download = `${name}.pdf`;
    link.click();

    window.URL.revokeObjectURL(url);
  }

  revoke(objectUrls: Iterable<string>) {
    for (const url of objectUrls) {
      window.URL.revokeObjectURL(url);
    }
  }

  private toDocumentFile(content: ArrayBuffer): GedDocumentFile {
    const objectUrl = window.URL.createObjectURL(
      new Blob([content], { type: 'application/pdf' }),
    );

    return {
      content,
      pageCount: countPdfPages(content),
      byteLength: content.byteLength,
      objectUrl,
      safeUrl: this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl),
    };
  }
}
